@import '../../constants/spacing.module.less';

.bar {
  height: 100%;
  transition: all 300ms ease;
}

.multi-section-bar {
  display: flex;
  flex-direction: row;
  border-radius: @space-8;
  overflow: hidden;
  height: @space-8;
}
